import { onDomReady } from './dom-ready';

/**
 * If the URL has a hash referring to a specific element, handler is called
 * with that element when the DOM is ready, and again on any hashchange.
 */
export function onHashFragmentElement(handler: (element: HTMLElement) => void): void {
   function callHandlerWithElement() {
      if (window.location.hash) {
         const id = window.location.hash.slice(1);
         const element = document.getElementById(id);

         if (element) {
            handler(element);
         }
      }
   }

   onDomReady(callHandlerWithElement);
   window.addEventListener('hashchange', callHandlerWithElement);
}
